import { Component, computed, Input, signal, inject } from '@angular/core';
import { IAktionen, Product, PushPdfData, TextNodeType } from '@mwe/models';
import { EnvironmentService } from '@mwe/services';
import { isProductStrom, isProductStromOrGasOnly } from '@mwe/utils';
import { HeadlineService } from '../../headline/headline.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { BasicCardTitleComponent } from '../../cards/basic-card/basic-card-title/basic-card-title.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

/** TODO Outsource into separate Module as this component is too specific */
@Component({
  selector: 'mwe-benefits-card',
  templateUrl: './benefits-card.component.html',
  imports: [NgClass, NgTemplateOutlet, BasicCardComponent, BasicCardTitleComponent, TranslateDirective, TranslatePipe],
})
export class BenefitsCardComponent {
  headlineService = inject(HeadlineService, { optional: true })!;
  protected environmentService = inject(EnvironmentService);

  @Input() wrapperClass: string;

  @Input() headlineReference: TextNodeType | undefined;

  @Input() set voucherInfo(value: IAktionen | undefined) {
    this.voucherInfoSignal.set(value);
  }
  voucherInfoSignal = signal<IAktionen | undefined>(undefined);
  @Input() set products(value: Product[] | undefined) {
    this.productsSignal.set(value);
  }
  productsSignal = signal<Product[] | undefined>(undefined);

  isEligableForSepaBenefitsSignal = signal<boolean | undefined>(undefined);
  doShow = computed<boolean>(() => {
    return !!this.voucherInfoSignal();
  });
  pushPdfSignal = signal<PushPdfData | undefined>(undefined);
  stromOrGasProducts = computed<Product[]>(() => {
    return this.productsSignal()?.filter(p => isProductStromOrGasOnly(p)) || [];
  });
  hasStromProducts = computed<boolean>(() => this.stromOrGasProducts().filter(p => isProductStrom(p)).length > 0);
  voucherStrom = computed<string>(() => {
    if (this.voucherInfoSignal().infoTextKey?.length > 0) {
      if (this.voucherInfoSignal().infoTextKey[0].toLowerCase().startsWith('strom')) {
        return this.voucherInfoSignal().infoText[0];
      }
      return this.voucherInfoSignal().infoText[1];
    }
    return undefined;
  });
  voucherGas = computed<string>(() => {
    if (this.voucherInfoSignal().infoTextKey?.length > 0) {
      if (this.voucherInfoSignal().infoTextKey[0].toLowerCase().startsWith('strom')) {
        return this.voucherInfoSignal().infoText[1];
      }
      return this.voucherInfoSignal().infoText[0];
    }
    return undefined;
  });
  useWrapper = computed<boolean>(() => !!this.wrapperClass);

  constructor() {
    this.headlineService?.setReferenceHeadline(this.headlineReference ?? 'h2');
  }
}
